var app = angular.module("leonardo");

var ReportsDocumentListFilters = function(
  $scope,
  $state,
  $controller,
  $timeout,
  $rootScope,
  ReportService
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersDocuments;

  $scope.filters_options = [];

  $scope.initOptions = function() {
    $scope.filters_options = $scope.filters_base.concat([
      {
        id: 'name',
        name: 'File Name Contains',
        label: 'File Name Contains',
        inline: false,
        type: 'text',
        placeholder: 'File Name',
        condition: true,
        conflicts: [],
        onSubmit: $scope.display
      },
      {
        id: 'folder_name',
        name: 'Folder Name Contains',
        label: 'Folder Name Contains',
        inline: false,
        type: 'text',
        placeholder: 'Folder Name',
        condition: true,
        conflicts: [],
        onSubmit: $scope.display
      },
      {
        id: 'noticed',
        name: 'Noticed',
        label: 'Noticed',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'only_df',
        name: 'Only DF',
        label: 'Only DF',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'archive',
        name: 'Archive',
        label: 'Archive',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'expired',
        name: 'Expired',
        label: 'Expired',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'expired_warning',
        name: 'Expired Warning',
        label: 'Expired Warning',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'expired_from',
        name: 'Expired From',
        label: 'Expired From',
        inline: false,
        type: 'date',
        placeholder: 'Expired From',
        condition: true,
        conflicts: [],
        positionVertical: 'bottom',
        endDate: 'expired_to'
      },
      {
        id: 'expired_to',
        name: 'Expired To',
        label: 'Expired To',
        inline: false,
        type: 'date',
        placeholder: 'Expired To',
        condition: true,
        conflicts: [],
        positionVertical: 'bottom',
        startDate: 'expired_from'
      },
      {
        id: 'fields_active',
        name: 'Fields To Show',
        label: 'Fields To Show',
        inline: false,
        type: 'columns',
        placeholder: 'Select Fields',
        condition: true,
        options: ReportService.fieldsDocumentsReport,
        conflicts: []
      }
    ]);
  };

  $scope.initOptions();

  $rootScope.$broadcast('filters-report:initialized');

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', $state.current.missing_documents ?
      ReportService.TYPE_MISSING_DOCUMENTS : ReportService.TYPE_EXISTING_DOCUMENTS);
  }, 100);


};

app.controller('ReportsDocumentListFilters', [
  '$scope',
  '$state',
  '$controller',
  '$timeout',
  '$rootScope',
  'ReportService',
  ReportsDocumentListFilters
]);
